function FindUnhandledData(data: any, handledKeys: any[]) {
  const unhandledData: any = {};

  Object.keys(data).forEach(key => {
    if (!handledKeys.includes(key)) {
      unhandledData[key] = data[key];
    }
  });

  return unhandledData;
}

export default FindUnhandledData;
